import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { COLORS, INITIATIVE_STATUS_COLORS, STATUS_COLORS } from '../constants/config';

type BadgeVariant = 'success' | 'warning' | 'danger' | 'info' | 'primary' | 'secondary' | 'default';
type InitiativeStatus = 'planning' | 'in_progress' | 'completed' | 'on_hold' | 'cancelled';

interface BadgeProps {
  text: string;
  variant?: BadgeVariant;
  status?: InitiativeStatus;
  size?: 'small' | 'medium' | 'large';
}

export default function Badge({ text, variant = 'default', status, size = 'medium' }: BadgeProps) {
  const getBackgroundColor = () => {
    if (status) {
      return INITIATIVE_STATUS_COLORS[status] || COLORS.gray;
    }

    switch (variant) {
      case 'success':
        return COLORS.success;
      case 'warning':
        return COLORS.warning;
      case 'danger':
        return COLORS.danger;
      case 'info':
        return COLORS.info;
      case 'primary':
        return COLORS.primary;
      case 'secondary':
        return COLORS.secondary;
      default:
        return COLORS.gray;
    }
  };

  const getTextColor = () => {
    if (variant === 'warning') return COLORS.dark;
    return COLORS.white;
  };

  const sizeStyles = {
    small: { paddingHorizontal: 6, paddingVertical: 2, fontSize: 10 },
    medium: { paddingHorizontal: 10, paddingVertical: 4, fontSize: 12 },
    large: { paddingHorizontal: 14, paddingVertical: 6, fontSize: 14 },
  };

  return (
    <View
      style={[
        styles.badge,
        {
          backgroundColor: getBackgroundColor(),
          paddingHorizontal: sizeStyles[size].paddingHorizontal,
          paddingVertical: sizeStyles[size].paddingVertical,
        },
      ]}
    >
      <Text
        style={[
          styles.text,
          { color: getTextColor(), fontSize: sizeStyles[size].fontSize },
        ]}
      >
        {text}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  badge: {
    borderRadius: 20,
    alignSelf: 'flex-start',
  },
  text: {
    fontWeight: '600',
    textAlign: 'center',
  },
});
